import { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Dialog } from '../../../components/Dialog';

export function Converter({ file }) {
  const [details, setDetails] = useState();

  function showDetails() {
    return details ? (
      <Dialog
        title="Metadata"
        onCancel={() => setDetails(null)}
        actions={false}
        width="md"
      >
        <Box sx={{ minHeight: 400 }}>
          <Box
            component="pre"
            sx={{
              backgroundColor: 'grey.100',
              p: 2,
              borderRadius: 1,
              overflow: 'auto',
              fontSize: '0.875rem',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
            }}
          >
            {JSON.stringify(details, null, 2)}
          </Box>
        </Box>
      </Dialog>
    ) : null;
  }

  return (
    <>
      {showDetails()}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <span>{file.convertedBy}</span>
        {file.metadata?.leaf ? (
          <IconButton
            onClick={() => setDetails(file.metadata.leaf)}
            size="small"
            sx={{ padding: 0, color: 'inherit' }}
          >
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        ) : null}
      </Box>
    </>
  );
}
